var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { TextBody, Box, get } from '@ally/metronome-ui';
import styled from 'styled-components';
import React from 'react';
import AosStkProgressBar from '@ally/aos-stk-progress-bar';
import { formatCurrency } from '@ally/aos-utils';
var SrOnly = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), get.screenReader('srOnly'));
export function AosStkBucketGoalTracker(_a) {
    var monetaryGoalProgress = _a.monetaryGoalProgress, bucketGoalAmount = _a.bucketGoalAmount, _b = _a.skinny, skinny = _b === void 0 ? false : _b;
    var formattedBucketGoalAmount = formatCurrency.asCurrency(bucketGoalAmount);
    return (React.createElement(React.Fragment, null,
        React.createElement(SrOnly, null, "You've completed " + monetaryGoalProgress + "% of your " + formattedBucketGoalAmount + " goal"),
        React.createElement(Box, { "aria-hidden": true, "data-testid": "bucket-goal-tracker" },
            React.createElement(AosStkProgressBar, { total: bucketGoalAmount, percentage: monetaryGoalProgress, skinny: skinny }),
            React.createElement(TextBody, { size: "xs", tag: "div", weight: "bold", textAlign: "right" }, "" + formattedBucketGoalAmount))));
}
export default AosStkBucketGoalTracker;
var templateObject_1;
//# sourceMappingURL=index.js.map